import React from "react";
import { Overline } from "../../../../ForBrands/ui/BrandUI";
import CollapsibleCard from "../../../../ForBrands/ui/CollapsibleCard";
import InsightList from "../../../../ForBrands/ui/InsightList";
import { LegendRow } from "../../../../ForBrands/ui/LegendItem";
import StackBar from "../../../../ForBrands/ui/charts/StackBar";
import { CHART } from "../../../../ForBrands/ui/charts/chartTokens";
import { NO_PATTERN, rankLede, shotProfileView } from "../teamPerformanceModel";
import { CardNote, PerfTile, TileGrid } from "./perfPieces";

// Shot Profile & Scoring Mix (BUILD_SPEC B7, Jayson's T6): where the points
// come from as one 100% bar (2PT bm-ink, 3PT bm-orange, FT bm-orange at
// 40%: one scheme on both pages, B18) with every share in its legend, the
// opponents' mix in words, then 3PA rate (descriptive: a passive chip),
// 3P%, 2P% and FT% as tiles (2 x 2 on phones), and the reads. Ranked rates
// name their peer group in the lede (B5); the legend says what the 3PA
// rate's passive "Nth pct" means.

const ShotProfileCard = ({ payload, peer, collapse }) => {
  const view = shotProfileView(payload);
  return (
    <CollapsibleCard title="Shot Profile & Scoring Mix" titleAs="h3" subtitle={view.ranked ? rankLede(peer) : null} {...collapse}>
      <div className="flex flex-col gap-2">
        <Overline>Where the points come from</Overline>
        {view.segments.length ? <StackBar segments={view.segments} legend legendLabel="Scoring mix" /> : <CardNote>No scoring mix on file.</CardNote>}
        <CardNote>{view.opponentLine}</CardNote>
      </div>
      {view.rates.length > 0 && (
        <TileGrid columns={4} label="Shooting rates">
          {view.rates.map((tile) => (
            <PerfTile key={tile.key} tile={tile} band />
          ))}
        </TileGrid>
      )}
      <LegendRow
        items={[view.descriptiveNote && { key: "descriptive", swatch: "dot", color: CHART.muted, label: view.descriptiveNote }]}
        label="Shooting rates legend"
      />
      <InsightList insights={view.insights} variant="callout" emptyText={NO_PATTERN} />
    </CollapsibleCard>
  );
};

export default ShotProfileCard;
